module.exports = __webpack_public_path__ + "static/battle_16-8118231d65116e6aae9a664c5c562214.jpg";